"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var DriversCompany_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriversCompany = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const statusGetter_1 = require("../statusGetter");
const transformToDate_1 = require("../transformers/transformToDate");
const Document_1 = require("./Document");
const DriverActivity_1 = require("./DriverActivity");
const Position_1 = require("./Position");
const Score_1 = require("./Score");
let DriversCompany = DriversCompany_1 = class DriversCompany {
    name;
    managementNote = "";
    town = "";
    address = "";
    position;
    // Functionality removed - field kept only for historical data
    originLocationIds = [];
    willingToRentVehicleTypes = [];
    documents = [];
    hiredAt = new Date();
    hireReason;
    activeAt;
    declinedAt;
    score = new Score_1.Score();
    activity;
    get status() {
        return (0, statusGetter_1.statusGetter)(this, DriversCompany_1, legacy_enums_1.DriversCompanyStatus);
    }
    static statusPrototype(status) {
        const defined = new Date();
        switch (status) {
            case legacy_enums_1.DriversCompanyStatus.Declined:
                return {
                    declinedAt: defined,
                };
            case legacy_enums_1.DriversCompanyStatus.Active:
                return {
                    activeAt: defined,
                    declinedAt: undefined,
                };
            case legacy_enums_1.DriversCompanyStatus.Hired:
                return {
                    hiredAt: defined,
                    activeAt: undefined,
                    declinedAt: undefined,
                };
            case legacy_enums_1.DriversCompanyStatus.Lead:
                return {
                    hiredAt: undefined,
                    activeAt: undefined,
                    declinedAt: undefined,
                };
            default: {
                throw new Error(legacy_enums_1.RejectionType.ServerError);
            }
        }
    }
    hiredByUserId;
    acquisitionCost;
    willingToDoLite = false;
    apiKey;
    isNotDomesticVATPayer = false;
    hasOfferPriority = false;
    claimingFeeChange;
    rentalReason;
    shareCustomerContactEarly = false;
};
exports.DriversCompany = DriversCompany;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DriversCompany.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DriversCompany.prototype, "managementNote", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DriversCompany.prototype, "town", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DriversCompany.prototype, "address", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Position_1.Position),
    __metadata("design:type", Position_1.Position)
], DriversCompany.prototype, "position", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], DriversCompany.prototype, "originLocationIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Number),
    __metadata("design:type", Array)
], DriversCompany.prototype, "willingToRentVehicleTypes", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Document_1.Document),
    __metadata("design:type", Array)
], DriversCompany.prototype, "documents", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], DriversCompany.prototype, "hiredAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DriversCompany.prototype, "hireReason", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], DriversCompany.prototype, "activeAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], DriversCompany.prototype, "declinedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Score_1.Score),
    __metadata("design:type", Score_1.Score)
], DriversCompany.prototype, "score", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => DriverActivity_1.DriverActivity),
    __metadata("design:type", DriverActivity_1.DriverActivity)
], DriversCompany.prototype, "activity", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DriversCompany.prototype, "hiredByUserId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], DriversCompany.prototype, "acquisitionCost", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], DriversCompany.prototype, "willingToDoLite", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], DriversCompany.prototype, "apiKey", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], DriversCompany.prototype, "isNotDomesticVATPayer", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], DriversCompany.prototype, "hasOfferPriority", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], DriversCompany.prototype, "claimingFeeChange", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], DriversCompany.prototype, "rentalReason", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], DriversCompany.prototype, "shareCustomerContactEarly", void 0);
exports.DriversCompany = DriversCompany = DriversCompany_1 = __decorate([
    (0, class_transformer_1.Exclude)()
], DriversCompany);
//# sourceMappingURL=DriversCompany.js.map